import { Button, Col, Row, Table } from 'antd';
import React, { useEffect, useState } from 'react'
import { API_ROUTE } from '../../../utils/commonConstants';
import { GET } from '../../../utils/requestActionConstants';
import { fetcher } from '../../../helpers/processRequest';
import useSWR from 'swr';
import { ticketTabConfig } from '../TicketsTab';
import { useDispatch, useSelector } from 'react-redux';
import { setTickets, setTicket } from '../../../store/slices/ticketSlice';
import SearchComponent from '../../../components/SearchComponent';


function TicketList({onSwitchTab}) {
    const dataFetcher = useSWR({method: GET, url: API_ROUTE + '/tickets'} , fetcher);
    const state = useSelector(state => state.ticketSlice);
    const dispatch = useDispatch();
    const [filteredData, setFilteredData] = useState([]);

    const edit = (data) => {
        dispatch(setTicket(data))
        onSwitchTab(ticketTabConfig.ADD, data);
    }
    
    useEffect(() => {
      if (dataFetcher.data?.data) {
        dispatch(setTickets(dataFetcher.data.data));
      }
    }, [dataFetcher.data?.data])

    const columns = [
        {
          title: 'Name',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: 'Email',
          dataIndex: 'email',
          key: 'email',
        },
        {
          title: 'Telephone',
          dataIndex: 'telephone',
          key: 'telephone',
        },
        {
          title: 'Message',
          dataIndex: 'message',
          key: 'message',
        },
        // {
        //     title: 'Action',
        //     key: 'action',
        //     render: (_, record) => (
        //         <>
        //             <div>
        //                 <Button onClick={() => edit(record)}>View More</Button>
        //             </div>
        //         </>
        //     )
        // }
      ];

      const onFilter = (filteredData) => {
        setFilteredData(filteredData);
      }
    
      return (
        <div className='overflow-x-auto' p={2} sx={{ height: '100%' }}>
          <SearchComponent masterData={state.ticketList} onFilter={onFilter} filterByKeys={['title', 'message', 'name', 'telephone', 'email']} />
            <div className='overflow-x-auto'>
              <Table columns={columns} dataSource={filteredData} pagination={false} loading={dataFetcher.isLoading || dataFetcher.isValidating} />
            </div>
        </div>
      );
}

export default TicketList